import { t } from './i18n';
import { ReactComponent as TruckSVG } from './YardView/TruckSVG.svg';
import './StatusConfig.css'
import React, { useState, useRef, useEffect } from 'react';
// Note: do NOT call hooks at module scope. StatusConfig is pure data.

export const statusConfig = {

    pending: {
        key: 'pending',
        dotClass: 'pending',
        translationKey: 'StatusDescr.pending',
        exampleKey: 'StatusExample.pending',
        example: 'Η κράτηση δημιουργήθηκε, περιμένει επιβεβαίωση.',
        statusId: 1,
        color: '#ebb917',
        showBorder: true
    },
    change: {
        key: 'change',
        dotClass: 'change',
        translationKey: 'StatusDescr.change',
        exampleKey: 'StatusExample.change',
        example: 'Η κράτηση τροποποιήθηκε και περιμένει νέα επιβεβαίωση.',
        statusId: 2,
        color: '#20c997',
        showBorder: true
    },
    preliminarDetention: {
        key: 'preliminarDetention',
        dotClass: 'preliminarDetention',
        translationKey: 'StatusDescr.preliminarDetention',
        exampleKey: 'StatusExample.preliminarDetention',
        example: 'Προγραμματισμένη ή επαναλαμβανόμενη κράτηση.',
        statusId: 3,
        color: '#374151',
        showBorder: true
    },
    canceled: {
        key: 'canceled',
        dotClass: 'canceled',
        translationKey: 'StatusDescr.canceled',
        exampleKey: 'StatusExample.canceled',
        example: 'Η κράτηση ακυρώθηκε από τον Planner.',
        statusId: 4,
        color: '#B91C1C',
        showBorder: true
    },
    accepted: {
        key: 'accepted',
        dotClass: 'accepted',
        translationKey: 'StatusDescr.accepted',
        exampleKey: 'StatusExample.accepted',
        example: 'Η κράτηση επιβεβαιώθηκε και είναι ενεργή.',
        statusId: 5,
        color: '#047857',
        showBorder: true
    },
    arrived: {
        key: 'arrived',
        dotClass: 'arrived',
        translationKey: 'StatusDescr.arrived',
        exampleKey: 'StatusExample.arrived',
        example: 'Το όχημα έφτασε στην Αυλή της Αποθήκης.',
        statusId: 6,
        color: '#2596FF',
        showBorder: true
    },
    loading: {
        key: 'loading',
        dotClass: 'loading',
        translationKey: 'StatusDescr.loading',
        exampleKey: 'StatusExample.loading',
        example: 'Το όχημα φορτώνεται αυτή τη στιγμή.',
        statusId: 7,
        color: '#14AE5C',
        showBorder: true
    },
    finished: {
        key: 'finished',
        dotClass: 'finished',
        translationKey: 'StatusDescr.finished',
        exampleKey: 'StatusExample.finished',
        example: 'Η διαδικασία ολοκληρώθηκε επιτυχώς.',
        statusId: 8,
        color: '#8D97B0',
        showBorder: true
    }
};

export const yardViewStatusConfig = {
    expected: {
        key: 'expected',
        dotClass: 'expected',
        translationKey: 'StatusDescr.expected',
        yardViewLabel: 'profileMenu.statusItems.expected',
        exampleKey: 'StatusExample.yard_expected',
        example: 'Το όχημα αναμένεται να φτάσει στο yard σύμφωνα με την κράτηση.',
        statusId: 1,
        color: '#A6D4FF'
    },
    arrived: {
        key: 'arrived',
        dotClass: 'arrived',
        translationKey: 'StatusDescr.arrived',
        yardViewLabel: 'profileMenu.statusItems.arrived',
        exampleKey: 'StatusExample.yard_arrived',
        example: 'Το όχημα έχει φτάσει στο yard και καταγράφηκε η άφιξή του.',
        statusId: 2,
        color: '#2596FF'
    },
    readyToLoad: {
        key: 'readyToLoad',
        dotClass: 'ready-to-load',
        translationKey: 'StatusDescr.readyToLoad',
        yardViewLabel: 'profileMenu.statusItems.readyToLoad',
        exampleKey: 'StatusExample.yard_readyToLoad',
        example: 'Το όχημα είναι έτοιμο και περιμένει να ξεκινήσει η φόρτωση.',
        statusId: 3,
        color: '#8CF553'
    },
    loading: {
        key: 'loading',
        dotClass: 'loading',
        translationKey: 'StatusDescr.loading',
        yardViewLabel: 'profileMenu.statusItems.loading',
        exampleKey: 'StatusExample.yard_loading',
        example: 'Το όχημα βρίσκεται αυτή τη στιγμή στη διαδικασία φόρτωσης.',
        statusId: 4,
        color: '#14AE5C'
    },
    finished: {
        key: 'finished',
        dotClass: 'finished',
        translationKey: 'StatusDescr.finished',
        yardViewLabel: 'profileMenu.statusItems.finished',
        exampleKey: 'StatusExample.yard_finished',
        example: 'Η φόρτωση ολοκληρώθηκε και το όχημα έφυγε από το yard.',
        statusId: 5,
        color: '#8D97B0'
    }
};

export function StatusItem({ config, language, isCalendarView = true }) {
    const statusLabel = isCalendarView
        ? t(config.translationKey, language)
        : t(config.yardViewLabel || config.translationKey, language);

    return (
        <span className="compact-status-item">
            <span
                className={`status-dot${isCalendarView ? '-calendar' : ''} ${config.dotClass} compact-dot`}
                style={!isCalendarView ? { backgroundColor: config.color } : {}}
            ></span>
            <span className={isCalendarView ? "compact-status-text" : ""}>
                {statusLabel}
            </span>
            <div className="status-tooltip">
                <div className="status-tooltip-header">
                    <div className="status-tooltip-title">
                        {t(config.translationKey, language)}
                    </div>
                </div>

                <div className="status-tooltip-body">
                    <div className="status-tooltip-desc">
                        {config.exampleKey ? t(config.exampleKey, language) : config.example}
                    </div>

                    {config.showBorder && isCalendarView && (
                        <div
                            className='example-event-status example-preview'
                            style={{ borderTop: `4px solid ${config.color}` }}
                        >
                            <span className="example-event-text">{t('ModalBooking.bookingSimple', language)}</span>
                        </div>
                    )}

                    {!isCalendarView && (
                        <div className="truck-preview" style={{ color: `${config.color}` }}>
                            <TruckSVG className="truck-svg" style={{ width: '100%', height: '100%' }} />
                        </div>
                    )}
                </div>
            </div>
        </span>
    );
}

export function CalendarStatusBar({ language }) {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const calendarStatuses = [
        statusConfig.pending,
        statusConfig.change,
        statusConfig.preliminarDetention,
        statusConfig.canceled,
        statusConfig.accepted,
        statusConfig.arrived,
        statusConfig.loading,
        statusConfig.finished
    ];

    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="status-bar-container" ref={menuRef}>
            {/* Mobile Toggle Button (770px and below) */}
            <div className="mobile-status-toggle">
                <button 
                    className={`status-toggle-button ${isOpen ? 'active' : ''}`}
                    onClick={toggleMenu}
                    title={t('profileMenu.status', language)}
                >
                    <i className="bi bi-info-circle"></i>
                    <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
                </button>
                
                {isOpen && (
                    <div className="status-toggle-menu">
                        <div className="compact-status-items">
                            {calendarStatuses.map((config) => (
                                <StatusItem
                                    key={config.key}
                                    config={config}
                                    language={language}
                                    isCalendarView={true}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* Desktop Compact Bar (771px and above) */}
            <div className="desktop-status-bar">
                <div className="compact-status-bar">
                    <div className="compact-status-inner">
                        <i className="bi bi-info-circle" style={{ marginRight: '8px', marginBottom: '4px' }}></i>
                        <span className="status-title compact-status-title">
                            {t('profileMenu.status', language)}:
                        </span>
                        <div className="compact-status-items">
                            {calendarStatuses.map((config) => (
                                <StatusItem
                                    key={config.key}
                                    config={config}
                                    language={language}
                                    isCalendarView={true}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function YardViewStatusBar({ language }) {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const yardStatuses = [
        yardViewStatusConfig.expected,
        yardViewStatusConfig.arrived,
        yardViewStatusConfig.readyToLoad,
        yardViewStatusConfig.loading,
        yardViewStatusConfig.finished
    ];

    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="status-bar-container" ref={menuRef}>
            {/* Mobile Toggle Button (770px and below) */}
            <div className="mobile-status-toggle">
                <button 
                    className={`status-toggle-button ${isOpen ? 'active' : ''}`}
                    onClick={toggleMenu}
                    title={t('profileMenu.status', language)}
                >
                    <i className="bi bi-info-circle"></i>
                    <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
                </button>
                
                {isOpen && (
                    <div className="status-toggle-menu">
                        <div className="compact-status-items">
                            {yardStatuses.map((config) => (
                                <StatusItem
                                    key={config.key}
                                    config={config}
                                    language={language}
                                    isCalendarView={false}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* Desktop Compact Bar (771px and above) */}
            <div className="desktop-status-bar">
                <div className="compact-status-bar">
                    <div className="compact-status-inner">
                        <i className="bi bi-info-circle" style={{ marginRight: '8px', marginBottom: '4px' }}></i>
                        <span className="status-title compact-status-title">
                            {t('profileMenu.status', language)}:
                        </span>
                        <div className="compact-status-items">
                            {yardStatuses.map((config) => (
                                <StatusItem
                                    key={config.key}
                                    config={config}
                                    language={language}
                                    isCalendarView={false}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
